import { createGlobalStyle } from 'styled-components';

/*
eggshell: fbfaf1
mint cream: F4FFF8
gold: fecc27
blue: 0070b7
gray: 828282
dark gray: 36434d
*/

export const GlobalStyle = createGlobalStyle`
  * {
    background-color: #FFF;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
`